import React from 'react';
import classnames from 'classnames';
import { string, number, arrayOf } from 'prop-types';
import { isEmpty } from 'lodash';
import { shouldDisplayIndustryFilter } from '../../../utils/industries';
import { InlineDivider } from '../InlineDivider';
import Country from './Country';
import Industry from './Industry';

const ReviewerSubDetails = ({ className = '', countryCode, reviewerIndustry, position }) => {
    const displayIndustry = shouldDisplayIndustryFilter() && !isEmpty(reviewerIndustry);

    if (!countryCode && !displayIndustry) {
        return null;
    }

    return (
        <div className={classnames('reviewer-sub-details flex', className)}>
            {countryCode && <Country code={countryCode} />}
            {displayIndustry && (
                <>
                    {countryCode && <InlineDivider />}
                    <Industry position={position} reviewerIndustry={reviewerIndustry} />
                </>
            )}
        </div>
    );
};

ReviewerSubDetails.propTypes = {
    className: string,
    countryCode: string,
    reviewerIndustry: arrayOf(string),
    position: number,
};

export default ReviewerSubDetails;
